module.exports = __webpack_public_path__ + "img/products.06aa1e25.svg";